export default __webpack_public_path__ + "img/1ffeccdd1e8d259b07b6fe31bac2d349.svg";